import { kml } from '@tmcw/togeojson';
import { DOMParser } from '@xmldom/xmldom';

export const parseKmlToGeoJson = async (file: File): Promise<number[][][] | null> => {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = (e) => {
      try {
        const text = e.target?.result as string;
        const parser = new DOMParser();
        const doc = parser.parseFromString(text, 'text/xml');
        const geoJson = kml(doc);

        if (geoJson.features && geoJson.features.length > 0) {
            // On cherche le premier Feature qui est un Polygon ou MultiPolygon
            const polygonFeature = geoJson.features.find(f => 
                f.geometry && (f.geometry.type === 'Polygon' || f.geometry.type === 'MultiPolygon')
            );

            if (polygonFeature && polygonFeature.geometry.type === 'Polygon') {
                resolve(polygonFeature.geometry.coordinates as number[][][]);
            } else {
                console.error('No polygon found in KML');
                resolve(null);
            }
        } else {
            resolve(null);
        }
      } catch (err) {
        console.error('Error parsing KML', err);
        reject(err);
      }
    };
    reader.onerror = (err) => reject(err);
    reader.readAsText(file);
  });
};

